export const CHAIN_ID = 56;
export const INFURA_KEY = "c6dbbd4cb8cc4dc9b1c9cf9bb5404910";

export const ETH_CHAIN_ID = 56;

export const CONTRACT_ADDRESSES = {
  approveToken: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
  stakingContract: "0xD98081d8b1919C8117Cff9D38645115ca3792A75",
  darknessContract: "0x5AbDB52dD8f2FA955f4cf5Ac4bd8ca127d6C68E2",
};

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const UINT256_MAX =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";
